import React, { useContext } from 'react';
import { WebRTCContext } from './contexts/WebRTCContext';

export default function VideoChatLocal() {
  const {
    localVideoRef,
    remoteVideoRef,
    roomId,
    handleOpenMedia,
    handleOpenAudioOnly,
    createRoom,
    hangUp
  } = useContext(WebRTCContext);

  return (
    <div>
      <h2>Video Chat</h2>
      <div>
        <button onClick={handleOpenMedia}>Open Media</button>
        <button onClick={handleOpenAudioOnly}>Open Audio Only</button>
        <button onClick={createRoom}>Create Room</button>
        <button onClick={hangUp}>Hang Up</button>
      </div>
      <div>
        <video ref={localVideoRef} autoPlay playsInline muted style={{ width: '300px', border: '1px solid #ccc' }} />
        <video ref={remoteVideoRef} autoPlay playsInline style={{ width: '300px', border: '1px solid #ccc' }} />
      </div>
      {roomId && <p>Current Room ID: {roomId}</p>}
    </div>
  );
}